module.exports.detectYouTubeUrl = (url) => {
    if (!url) {
        return false;
    }

    const params = [
        'youtube',
        'youtube.com',
        'youtu.be'
    ];
    
    let validation = false;

    url = url.toLowerCase();

    params.forEach((param) => {
        if (url.includes(param)) {
            validation = true;
        }
    });

    return validation;

}